module.exports = __webpack_public_path__ + "img/cir-cen2.8e0a063f.png";